module.exports = __webpack_public_path__ + "img/hr-green-asterisk-06.d1748ddc.png";